// Task comments client (plan §4, spec F4). Plain text: the body goes out and comes back as typed.
// A create carries an Idempotency-Key so a retry on a slow phone makes one comment (spec §8.8).
import type { Http } from './http.ts';
import { pathSegment } from './paths.ts';
import {
  commentPageSchema,
  commentSchema,
  type Comment,
  type CommentPage,
} from './schemas/comments.ts';

export * from './schemas/comments.ts';

export const COMMENT_MAX_LENGTH = 4000;

export interface CommentsApi {
  list(taskId: string, page: number, pageSize: number, signal?: AbortSignal): Promise<CommentPage>;
  add(taskId: string, body: string, idempotencyKey: string): Promise<Comment>;
  remove(taskId: string, commentId: number): Promise<void>;
}

const base = (taskId: string): string => `/tasks/${pathSegment(taskId)}/comments`;

export function createCommentsApi(http: Http): CommentsApi {
  return {
    list: async (taskId, page, pageSize, signal) =>
      http.json(
        {
          method: 'GET',
          path: `${base(taskId)}?page=${String(page)}&pageSize=${String(pageSize)}`,
          signal,
        },
        commentPageSchema,
      ),
    add: async (taskId, body, idempotencyKey) =>
      http.json(
        { method: 'POST', path: base(taskId), body: { body }, idempotencyKey },
        commentSchema,
      ),
    remove: async (taskId, commentId) =>
      http.noContent({ method: 'DELETE', path: `${base(taskId)}/${pathSegment(commentId)}` }),
  };
}
